export type TWorkType = 'FullTime' | 'Internship';
export const WORK_TYPE_FULL_TIME: TWorkType = 'FullTime';
export const WORK_TYPE_INTERNSHIP: TWorkType = 'Internship';
export const UNSUPPORTED_BROWSER = 'Unsupported Browser';
export const UNSUPPORTED_WEBRTC = `This browser doesn't support native video chat. Please use a modern web browser, such as Chrome or Firefox running on Windows or macOS`;
export const UNSUPPORTED_MOBILE = `The page isn't supported on mobile devices, please use Chrome or Firefox on Windows or macOS`;
export const UNSUPPORTED_IOS_BROWSER = 'This page isn\'t supported on this browser, please use Safari';
export const UNSUPPORTED_MOBILE_BROWSER = 'This browser doesn\'t support native video chat. Please use a modern browser, such as Chrome';

export interface IExperience {
  label: string;
  value: string;
}

export const experienceOptions: Array<IExperience> = [
  {label: 'Less than 1 year', value: 'less_1_year'},
  {label: '1 year', value: '1_year'},
  {label: '2 years', value: '2_years'},
  {label: '3 years', value: '3_years'},
  {label: '4 years', value: '4_years'},
  {label: '5 years', value: '5_years'},
  {label: '6 years', value: '6_years'},
  {label: '7 years', value: '7_years'},
  {label: '8 years', value: '8_years'},
  {label: '9 years', value: '9_years'},
  {label: '10+ years', value: '10_more_years'},
];

export interface IWorkAvailability {
  label: string;
  value: string;
}

export const workAvailabilityOptions: Array<IWorkAvailability> = [
  {label: 'Immediately', value: 'immediately'},
  {label: 'Within 2 weeks', value: '2_weeks'},
  {label: 'Within 1 month', value: '1_month'},
  {label: 'Within 2 months', value: '2_months'},
  {label: 'At least 3 months from now', value: '3_months_or_more'},
];

export interface IWorkAuthType {
  label: string;
  value: string;
}

export const workAuthTypeOptions: Array<IWorkAuthType> = [
  {label: 'US Citizen or Permanent Resident', value: 'Perm'},
  {label: 'H-1B Visa', value: 'H1B'},
  {label: 'H-4 Visa with a valid EAD', value: 'H4_EAD'},
  {label: 'L-1 Visa', value: 'L1'},
  {label: 'L-2 Visa', value: 'L2'},
  {label: 'F-1 or OPT Visa', value: 'F1_OPT'},
  {label: 'TN Visa', value: 'TN'},
  {label: 'O-1 Visa', value: 'O1'},
  {label: 'E-3 Visa', value: 'E3'},
  {label: 'I don\'t have a US Work Visa', value: 'NONE'},
  {label: 'Other', value: 'OTHER'},
];
